export default {
    setLang: (state, { lang }) => {
        state.lang = lang;
    },

    setBroker: (state, { broker }) => {
        state.broker = broker;
    },

    setCurrency: (state, { currency }) => {
        state.currency = currency;
    },

    setCacheTtl: (state, { cacheTtl }) => {
        state.cacheTtl = cacheTtl;
    },

    setSource: (state, { source }) => {
        state.source = source;
    },

    setHeaderOffset: (state, { headerOffset }) => {
        state.headerOffset = headerOffset;
    },

    setWidgetWidth: (state, { widgetWidth }) => {
        state.widgetWidth = widgetWidth;
    },

    setPlatforms: (state, { platforms }) => {
        state.platforms = platforms;
    },

    setGroups: (state, { groups }) => {
        state.groups = groups;
    },

    setSubgroups: (state, { subgroups }) => {
        state.subgroups = subgroups;
    },

    setColumns: (state, { columns }) => {
        state.columns = columns;
    },

    setInstruments: (state, { instruments }) => {
        state.instruments = instruments;
    },

    setPlatformCode: (state, { platformCode }) => {
        state.platformCode = platformCode;
    },

    setGroupId: (state, {groupId}) => {
        state.groupId = groupId;
    },

    setSubgroupsIds: (state, {subgroupsIds}) => {
        state.subgroupsIds = subgroupsIds;
    },

    setColumnsFieldsNames: (state, { columnsFieldsNames }) => {
        state.columnsFieldsNames = columnsFieldsNames;
    },

    setFilter: (state, { filter }) => {
        state.filter = filter;
    },

    setSortKey: (state, { sortKey }) => {
        state.sortKey = sortKey;
    },

    setSortIsAscending: (state, { sortIsAscending }) => {
        state.sortIsAscending = sortIsAscending;
    },

    setColumnsToShow: (state, { columns }) => {
        state.columnsToShow = columns;
    },

    setInstrumentsToShow: (state, { instruments }) => {
        state.instrumentsToShow = instruments;
    },

    setPlatformsLoadingId: (state, { updateId }) => {
        state.platformsLoadingId = updateId;
    },

    setGroupsLoadingId: (state, { updateId }) => {
        state.groupsLoadingId = updateId;
    },

    setSubgroupsLoadingId: (state, { updateId }) => {
        state.subgroupsLoadingId = updateId;
    },

    setColumnsLoadingId: (state, { updateId }) => {
        state.columnsLoadingId = updateId;
    },

    setInstrumentsLoadingId: (state, { updateId }) => {
        state.instrumentsLoadingId = updateId;
    },

    setIsDataLoading: (state, { flag }) => {
        state.isDataLoading = flag;
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js